import {
    initClient,
    setAssetDomain,
    thewest,
} from '@news-mono/component-library'
import { authCheckAccessToken } from '@news-mono/web-common'

setAssetDomain()
// We need this to get the dependencies loaded in the correct order
require('../app/app')

const { render, routeCacheRef } = initClient({
    version: { buildNumber: '', sha: '' },
    beforeInitialised: async ({ store, log, config }) => {
        await store.dispatch(
            authCheckAccessToken({
                onEvent: () => {},
                config,
                log,
                invocation: 'auto',
            }),
        )
    },
    requireApplication: () => require('../app/app').App,
    theme: thewest,
})

if (module.hot) {
    module.hot.accept('../app/app', () => {
        if (routeCacheRef) {
            routeCacheRef.clear()
        }

        setTimeout(render)
    })
}
